export const fetchNews=fetch=>{return()=>{return fetch("/manager/news")}};